import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtistsDirectory from "../pages/artists/page";
import About from "../pages/about/page";
import Register from "../pages/register/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artistas",
    element: <ArtistsDirectory />,
  },
  {
    path: "/registro",
    element: <Register />,
  },
  {
    path: "/sobre-nosotros",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;